import React, { lazy, Suspense } from 'react';
import { property } from 'underscore';
import { bootApp } from '../bv';
import componentDependencies from './component_dependencies';

export default (fallbackComponent = <></>) => (componentKey) => {
  const LazyComponent = lazy(() => {
    const {
      app,
      dependencies,
      getter,
      softDependencies,
    } = property(componentKey.split('.'))(componentDependencies);

    return bootApp({
      dependencies: dependencies || [],
      softDependencies,
      app,
    }).then(getter);
  });

  return (props) => (
    <Suspense fallback={fallbackComponent}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
